




import Vue from "vue"
import PResetRequestPage from "~/components/custom/reset/PResetRequestPage.vue"

export default Vue.extend({
  components: {
    PResetRequestPage,
  },
  layout: "auth",
  head(): object {
    return this.$clHelpers.metaTag.generate({
      title: "パスワードリセット",
      currentPath: this.$nuxt.$route.path,
    })
  },
})
